import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageHeader from "../component/layout/pageheader";
import MemberShip from "../component/section/memberShip";
import { toastMaker, validateEmail } from "../utils/utility";
import { passwordStrength } from "check-password-strength";
import BannerSection from "../component/section/banner";
import matrimonyInstance from "../utils/axios";
import { CREATE_USER, JOIN_BAT } from "../API_LIST";
import Datetime from "react-datetime";
import moment from "moment";
import "react-datetime/css/react-datetime.css";
import LoaderComponent from "../component/loader/LoaderComponent";

const accountData = {
	email: "",
	first_name: "",
	middle_name: "",
	last_name: "",
	gotram: "",
	mobile_number: "",
	occupation: "",
	address: "",
	password: "",
};

const spouseData = {
	first_name: "",
	middle_name: "",
	last_name: "",
	gotram: "",
	occupation: "",
	email: "",
	relationship_id: 8,
};

const childData = {
	first_name: "",
	last_name: "",
	occupation: "",
	relationship_id: "",
	gotram: "",
	middle_name: "",
	email: "",
};

const JoinBAT = () => {
	const navigate = useNavigate();

	const [batAccountData, setBatAccountData] = useState(accountData);
	const [batSpouseData, setBatSpouseData] = useState(spouseData);
	const [batChildData, setBatChildData] = useState([childData]);

	const [confirmPassword, setIsConfirmPassword] = useState("");
	const [isTerms, setIsTerms] = useState(false);
	const [isRequired, setIsRequired] = useState(false);
	const [loading, setLoading] = useState(false);

	const [isVisiblePassword, setIsVisiblePassword] = useState(false);
	const [isConfirmVisible, setIsConfirmVisible] = useState(false);
	const [isRegisterPage, setIsRegisterPage] = useState(true);

	const handleChangeBatAccountData = (e) => {
		const { name, value, pattern } = e.target;
		let formattedValue = value;

		if (pattern && value) {
			let regex = new RegExp(pattern);
			let result = regex.test(value);
			if (!result) return;
		}

		// if (name === "mobile_number") {
		// 	formattedValue = formatPhoneNumber(value);
		// }

		setBatAccountData((prev) => ({
			...prev,
			[name]: formattedValue,
		}));
	};

	const handleChangeBatSpouseData = (e) => {
		const { value, pattern } = e.target;

		if (pattern && value) {
			let regex = new RegExp(pattern);
			let result = regex.test(value);
			if (!result) return;
		}
		setBatSpouseData((prev) => {
			return { ...prev, [e.target.name]: e.target.value };
		});
	};

	const handleChangeBatChildData = (e, index) => {
		const { value, pattern } = e.target;

		if (pattern && value) {
			let regex = new RegExp(pattern);
			let result = regex.test(value);
			if (!result) return;
		}
		const updatedChildData = batChildData.map((item, _index) => {
			if (index === _index) {
				return { ...item, [e.target.name]: e.target.value };
			}
			return item;
		});
		setBatChildData(updatedChildData);
	};

	const addChildren = () => {
		setBatChildData([...batChildData, childData]);
	};

	const removeChildren = (index) => {
		let temp = [...batChildData];
		temp.splice(index, 1);
		setBatChildData(temp);
	};

	let data = {
		batAccount: batAccountData,
		batFamily: [batSpouseData, ...batChildData],
	};

	const createUser = async (e) => {
		e.preventDefault();
		setIsRequired(true);

		if (
			batAccountData.first_name == "" ||
			batAccountData.last_name == "" ||
			batAccountData.email == "" ||
			batAccountData.gotram == "" ||
			batAccountData.mobile_number == "" ||
			batAccountData.address == "" ||
			batAccountData.password == ""
		) {
			return toastMaker("Missing required fields", "error");
		}

		if (!isTerms) {
			return toastMaker("Please Agree to our disclosure & waiver.", "error");
		}
		setLoading(true);

		matrimonyInstance
			.post(JOIN_BAT, data)
			.then((response) => {
				toastMaker("BAT Registration Succesfull", "success");
				setLoading(false);
				navigate("/confirmation");
			})
			.catch((error) => {
				console.log("error");
				setLoading(false);
				toastMaker(error, "Error");
			});
	};

	const formatPhoneNumber = (value) => {
		// Remove all non-digit characters
		const cleaned = value.replace(/\D/g, "");

		if (cleaned.length === 0) return ""; // If empty, return empty

		// Format based on length
		if (cleaned.length <= 3) {
			return `(${cleaned}`;
		} else if (cleaned.length <= 6) {
			return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
		} else {
			return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
		}
	};

	return (
		<div className="container">
			{loading && <LoaderComponent />}
			<div className="login-section pt-50">
				<div className="row">
					<div className="col-12 col-lg-8 col-sm-12">
						<div className="account-container">
							<h3 className="account-title">
								{isRegisterPage ? "Join BAT" : "Terms & Conditions Page"}
							</h3>
							<div className="account-wrapper">
								{isRegisterPage ? (
									<React.Fragment>
										<div className="account-form">
											<form onSubmit={createUser}>
												<div className="row row-gap-3 userclick-container mx-0">
													<div className="row mb-20 mx-0">
														<h5 className="mb-30">PRIMARY MEMBER DETAILS</h5>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			batAccountData?.first_name?.length ===
																				0 &&
																			"color-red"
																		}
																	>
																		First Name *
																	</span>
																</div>
																<input
																	type="text"
																	name="first_name"
																	pattern="^[a-zA-Z ]+$"
																	value={batAccountData.first_name}
																	onChange={handleChangeBatAccountData}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span>Middle Name</span>
																</div>
																<input
																	type="text"
																	name="middle_name"
																	pattern="^[a-zA-Z ]+$"
																	value={batAccountData.middle_name}
																	onChange={handleChangeBatAccountData}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			batAccountData?.last_name?.length === 0 &&
																			"color-red"
																		}
																	>
																		Last Name *
																	</span>
																</div>
																<input
																	type="text"
																	name="last_name"
																	pattern="^[a-zA-Z ]+$"
																	value={batAccountData.last_name}
																	onChange={handleChangeBatAccountData}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			batAccountData?.email?.length === 0 &&
																			"color-red"
																		}
																	>
																		Email *
																	</span>
																</div>
																<input
																	type="email"
																	name="email"
																	value={batAccountData.email}
																	onChange={handleChangeBatAccountData}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			batAccountData?.gotram?.length === 0 &&
																			"color-red"
																		}
																	>
																		Gotram *
																	</span>
																</div>
																<input
																	type="text"
																	name="gotram"
																	pattern="^[a-zA-Z ]+$"
																	value={batAccountData.gotram}
																	onChange={handleChangeBatAccountData}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			batAccountData?.mobile_number?.length ===
																				0 &&
																			"color-red"
																		}
																	>
																		Primary Contact Phone Number *
																	</span>
																</div>
																<input
																	type="tel"
																	name="mobile_number"
																	pattern="^\+?[0-9 ]{1,16}$"
																	value={batAccountData.mobile_number}
																	maxLength="15"
																	onChange={handleChangeBatAccountData}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span>Occupation</span>
																</div>
																<input
																	type="text"
																	name="occupation"
																	pattern="^[a-zA-Z ]+$"
																	value={batAccountData.occupation}
																	onChange={handleChangeBatAccountData}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			batAccountData?.address?.length === 0 &&
																			"color-red"
																		}
																	>
																		Communication Address *
																	</span>
																</div>
																<input
																	type="text"
																	name="address"
																	value={batAccountData.address}
																	onChange={handleChangeBatAccountData}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span
																		className={
																			isRequired &&
																			batAccountData?.password?.length === 0 &&
																			"color-red"
																		}
																	>
																		Password *
																	</span>
																</div>
																<input
																	type="password"
																	name="password"
																	maxLength={20}
																	value={batAccountData.password}
																	onChange={handleChangeBatAccountData}
																/>
															</div>
														</div>
														<h5 className="mb-30 mt-30">SPOUSE DETAILS</h5>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span>Spouse First Name</span>
																</div>
																<input
																	type="text"
																	name="first_name"
																	pattern="^[a-zA-Z ]+$"
																	value={batSpouseData.first_name}
																	onChange={handleChangeBatSpouseData}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span>Spouse Middle Name</span>
																</div>
																<input
																	type="text"
																	name="middle_name"
																	pattern="^[a-zA-Z ]+$"
																	value={batSpouseData.middle_name}
																	onChange={handleChangeBatSpouseData}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span>Spouse Maiden Last Name</span>
																</div>
																<input
																	type="text"
																	name="last_name"
																	pattern="^[a-zA-Z ]+$"
																	value={batSpouseData.last_name}
																	onChange={handleChangeBatSpouseData}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span>Spouse Maiden Gotram</span>
																</div>
																<input
																	type="text"
																	name="gotram"
																	pattern="^[a-zA-Z ]+$"
																	value={batSpouseData.gotram}
																	onChange={handleChangeBatSpouseData}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span>Spouse Email</span>
																</div>
																<input
																	type="email"
																	name="email"
																	value={batSpouseData.email}
																	onChange={handleChangeBatSpouseData}
																/>
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span>Spouse Occupation</span>
																</div>
																<input
																	type="occupation"
																	name="occupation"
																	pattern="^[a-zA-Z ]+$"
																	value={batSpouseData.occupation}
																	onChange={handleChangeBatSpouseData}
																/>
															</div>
														</div>

														{batChildData.map((item, index) => (
															<React.Fragment key={index}>
																<div className="d-flex align-items-center gap-3">
																	<h5 className="mb-30 mt-30">
																		#{index + 1} CHILD DETAILS
																	</h5>
																	<img
																		src="../../assets/images/bat-img/close.svg"
																		style={{ width: "20px", height: "20px" }}
																		className="cursor-pointer"
																		onClick={() => {
																			removeChildren(index);
																			console.log("index", index);
																		}}
																	/>
																</div>
																<div className="col-lg-6 col-sm-10 col-12 px-3 mb-20">
																	<label>Relation</label>
																	<select
																		name="relationship_id"
																		value={batChildData[index]?.relationship_id}
																		onChange={(e) =>
																			handleChangeBatChildData(e, index)
																		}
																		className="form-select rounded-1 mt-15"
																	>
																		<option value="" disabled>
																			Select
																		</option>
																		<option value="1">Son</option>
																		<option value="2">Daughter</option>
																	</select>
																</div>
																<div className="col-lg-6 col-sm-10 col-12 px-3">
																	<div className="form-group">
																		<div className="input-title">
																			<span>First Name</span>
																		</div>
																		<input
																			type="text"
																			name="first_name"
																			pattern="^[a-zA-Z ]+$"
																			value={batChildData[index]?.first_name}
																			onChange={(e) =>
																				handleChangeBatChildData(e, index)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-sm-10 col-12 px-3">
																	<div className="form-group">
																		<div className="input-title">
																			<span>Middle Name</span>
																		</div>
																		<input
																			type="text"
																			name="middle_name"
																			pattern="^[a-zA-Z ]+$"
																			value={batChildData[index]?.middle_name}
																			onChange={(e) =>
																				handleChangeBatChildData(e, index)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-sm-10 col-12 px-3">
																	<div className="form-group">
																		<div className="input-title">
																			<span>Last Name</span>
																		</div>
																		<input
																			type="text"
																			name="last_name"
																			pattern="^[a-zA-Z ]+$"
																			value={batChildData[index]?.last_name}
																			onChange={(e) =>
																				handleChangeBatChildData(e, index)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-sm-10 col-12 px-3">
																	<div className="form-group">
																		<div className="input-title">
																			<span>Gotram</span>
																		</div>
																		<input
																			type="text"
																			name="gotram"
																			pattern="^[a-zA-Z ]+$"
																			value={batChildData[index]?.gotram}
																			onChange={(e) =>
																				handleChangeBatChildData(e, index)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-sm-10 col-12 px-3">
																	<div className="form-group">
																		<div className="input-title">
																			<span>Email</span>
																		</div>
																		<input
																			type="text"
																			name="email"
																			value={batChildData[index]?.email}
																			onChange={(e) =>
																				handleChangeBatChildData(e, index)
																			}
																		/>
																	</div>
																</div>
																<div className="col-lg-6 col-sm-10 col-12 px-3">
																	<div className="form-group">
																		<div className="input-title">
																			<span>Occupation</span>
																		</div>
																		<input
																			type="text"
																			name="occupation"
																			pattern="^[a-zA-Z ]+$"
																			value={batChildData[index]?.occupation}
																			onChange={(e) =>
																				handleChangeBatChildData(e, index)
																			}
																		/>
																	</div>
																</div>
															</React.Fragment>
														))}
														<div
															className="mb-20 d-flex align-items-center gap-2 cursor-pointer"
															onClick={addChildren}
														>
															<img
																src="../../assets/images/bat-img/add.svg"
																style={{ width: "30px", height: "30px" }}
															/>
															<span>Add Child</span>
														</div>

														<div className="d-flex align-items-start gap-3 mt-10">
															<input
																type="checkbox"
																name=""
																id="terms-condition"
																checked={isTerms}
																onChange={() => setIsTerms(!isTerms)}
															/>
															<label
																className="content cursor-pointer"
																htmlFor="terms-condition"
															>
																Disclosure & Waiver: By submitting this
																application for membership of Brahmin
																Association of Texas (hereinafter referred to as
																BAT) online, the applicant(s) agree to abide by
																the BAT Constitution, Articles, Bylaws, Rules
																Regulations and Resolutions, whether currently
																in force or subsequently adopted. Further, the
																applicant(s) hereby voluntarily relinquishes the
																right to hold BAT, its officers and/or it's
																volunteers liable for any act or omission that
																may result in either legal or moral
																accountability, wheatear or not financial in
																nature, thereby waiving the right to any legal
																remedy that may otherwise be available at law or
																in equity. Additionally, with regards to any and
																all programs sponsored by BAT (which includes
																religious ceremonies and festivals), the
																applicant(s) agrees to, without dispute, not
																only honor, respect, dignify the scheduled
																event, but also to heed and comply with any
																ritual as directed by BAT executives and/or
																person(s) to whom such authority has been
																delegated by some/all of BAT committee members.
																Applicant fully understands and acknowledges
																that any violation of the terms contained herein
																shall be regarded as good cause for removal from
																the particular event, and may also result in
																suspension, temporary and/or permanent loss of
																BAT membership. *
															</label>
														</div>
														<button
															className="button login-btn create-btn text-white"
															onClick={createUser}
														>
															CREATE ACCOUNT
														</button>
													</div>
												</div>
											</form>
											<div className="account-bottom text-center">
												<p className="d-block cate pt-10">
													<p>
														If you are an existing BAT member, please log in
														using your BAT account
													</p>
												</p>
												<p className="mt-10">
													<Link to="/login" className="login-account">
														Login to your Account
													</Link>
												</p>
											</div>
										</div>
									</React.Fragment>
								) : (
									<div className="content">
										<ul className="list-style number mb-20">
											<li>
												The minimum age for registration with BAT MATRIMONY as a
												member is 18 years.
											</li>
											<li>
												The information provided by the member/member’s
												parent/legal guardian should be legitimate and true. The
												member/member’s parent/legal guardian would be liable
												and solely responsible for any consequences arising out
												of inaccurate or false information. BAT Matrimony will
												not be responsible for any false or inaccurate
												information provided by member/member’s parent/ legal
												guardian.
											</li>
											<li>
												BAT Matrimony reserves the right to refuse a member’s
												application for registration and also cancel a member’s
												registration if the information provided is false or
												misleading.
											</li>
											<li>
												Members should upload their most recent photographs (not
												older than three months). BAT Matrimony reserves the
												right to use these pictures on its website.
											</li>
											<li>
												BAT Matrimony will not undertake or involve in any
												financial negotiation or personal items such as gold,
												properties, etc on behalf of members.
											</li>
											<li>
												Membership registration fee is $150 USD for annual
												subscription. If the membership is not active, BAT
												Creations will not provide any of its services.
											</li>
											<li>
												Membership registration fees are non-refundable and
												non-transferable.
											</li>
											<li>
												The profiles of members are confidential and would be
												shared only after obtaining prior permission from the
												respective members/member’s parents/legal guardian.
											</li>
											<li>
												Members are required to update BAT Matrimony of any
												changes to their marital status. If a member marries
												subsequent to registering with BAT Matrimony, his/her
												membership would be cancelled.
											</li>
											<li>
												All content on (WEBSITE BAT MATRIMONY) website is the
												property of BAT Matrimony or its affiliates and is
												protected by copyright laws.
											</li>
											<li>
												BAT Matrimony reserves the right to change the existing
												terms and conditions without prior notice.
											</li>
											<li>
												BAT is not responsible for any legal allegations rising
												between the registered members in any way.
											</li>
										</ul>
										<div className="back-to-sugnup d-flex justify-content-center">
											<button
												type="button"
												onClick={() => setIsRegisterPage(true)}
												className="button login-btn text-white"
											>
												BACK TO REGISTER
											</button>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
					<div className="col-12 col-lg-4 col-sm-12">
						{/* <MemberShip /> */}
					</div>
				</div>
			</div>
		</div>
	);
};

export default JoinBAT;
